import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import Keycloak from 'keycloak-js';
import { environment } from 'src/environments/environment';


@Injectable()
export class KeycloakAuthInterceptor implements HttpInterceptor {
  constructor(private readonly keycloak: Keycloak) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.keycloak.token;
    if (token && (req.url.includes(environment.bwApiUrl) || req.url.includes(environment.wpApiUrl))) {
      const authReq = req.clone({
        setHeaders: { Authorization: `Bearer ${token}` }
      });
      return next.handle(authReq);
    }
    return next.handle(req);
  }
}